/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateDisclosureAcceptance} from '../api'

export const useMutationUpdateDisclosureAcceptance = createReactQueryMutationHook('updateDisclosureAcceptance', updateDisclosureAcceptance)
